
<div :class="jel_getClassObject(content)" class="cursor-pointer" @click.capture="gaPreventClick">
  <b-link
    v-bind="jel_getLienBinding(content.lien)"
    class="bouton-image position-relative d-flex align-items-center overflow-hidden"
  >
    <MediaImageFocalPoint
      :content="{
        formatRatio: '16x9',
        image: content.image,
      }"
      class="flex-fill justify-content-center"
    >
    </MediaImageFocalPoint>
    <span class="position-absolute px-2 texte-bouton">{{ content.libBouton }}</span>
  </b-link>
</div>
